import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { Link } from 'react-router-dom';
import logo from '../../images/jobfi.in.png';
import Mail from '../../images/mail.png'
import './Footer.scss'
import ExpandMoreIcon from '../utils/ExpandMoreIcon';
import useWindowDimensions from '../utils/WindowDimensions';

function Footer() {
const { width } = useWindowDimensions();
const isExpanded = () => {return width >= 768;}

    return (
        <div className='footer-wrp wrapper'>
            <div className='footer-content-wrp'>
                <div className="logo-wrp">
                    <img src={logo} alt="logo" />
                </div>
                <div className="footer-column-wrp">
                    <Accordion defaultExpanded={isExpanded()}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Categories</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="content">
                                <Link reloadDocument={true}  to="#">Graphics & Design</Link>
                                <Link reloadDocument={true} to="#">Digital Marketing</Link>
                                <Link reloadDocument={true} to="#">Writing & Translation</Link>
                                <Link reloadDocument={true} to="#">Video & Animation</Link>
                                <Link reloadDocument={true} to="#">Music & Audio Programming & Tech Data</Link>
                                <Link reloadDocument={true} to="#">Business</Link>
                                <Link reloadDocument={true} to="#">Lifestyle Sitemap</Link>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div className="footer-column-wrp">
                    <Accordion defaultExpanded={isExpanded()}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Community</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="content">
                                <Link reloadDocument={true} to="#">Home</Link>
                                <Link reloadDocument={true} to="#">Hire A Talent</Link>
                                <Link reloadDocument={true} to="#">About Us</Link>
                                <Link reloadDocument={true} to="#">FAQ's</Link>
                                <Link reloadDocument={true} to="#">Blog</Link>
                                <Link reloadDocument={true} to="#">Contact Us</Link>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div className="footer-column-wrp">
                    <Accordion defaultExpanded={isExpanded()}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="title">Others</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="content">
                                <Link reloadDocument={true} to="#">Privacy Policy</Link>
                                <Link reloadDocument={true} to="#">Terms & Conditions</Link>
                                <Link reloadDocument={true} to="#">Earnings</Link>
                                <Link reloadDocument={true} to="#">Disclaimer</Link>
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div className="footer-column-wrp contact-root">
                    <div className="title">Contact Us</div>
                    <div className="content">We have 24X7 support available for answering your queries and helping you deal with any work related issue on our platform</div>
                    <div className="reach-via">Reach us through mail</div>
                    <div className="mail-id-wrp">
                        <img src={Mail} alt="mail" />
                        <div>support@jobfi.in</div>
                    </div>
                </div>
            </div>
            <div className='divider'></div>
            <div className='copyright'>Copyright © 2022 . jobfi.in. All Rights Reserved.</div>
        </div>
    );
}

export default Footer;